import { logEvent } from "@Lib/analytics";
import styles from "./index.module.less";
import cx from "classnames";
import React, { useEffect } from "react";
import { g4 } from "../../../../utils/helper";

let TextMap = new Map([
  ["1", "領取優惠"],
  ["2", "一鍵詢價"],
  ["3", "規格配備"],
  ["4", "中古車"],
]);

class ArticleKindsItem extends React.Component {
  io = null;

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.scrollWatch(this.el);
  }

  componentDidUpdate() {
  }

  scrollWatch = (el) => {
    const { data } = this.props;
    let isFrist = false;

    try {
      this.io = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !isFrist) {
            isFrist = true;
            if (g4) {
              // g4("element_exposured", {
              //   page_name: "影音詳情頁",
              //   module: "相關車款、競爭車款",
              //   element: "車款列表",
              //   element_id: "競爭&相關車款入口",
              // });
              // g4("element_exposured", {
              //   page_name: "影音詳情頁",
              //   module: "相關車款、競爭車款",
              //   element: "車款列表",
              //   element_id: TextMap.get(data.btnStatus),
              // });
            }
          }
        },
        { threshold: [0.65] },
      );
      if (el) {
        this.io.observe(el);
      }
    } catch (e) {
      console.log(e);
    }
  };

  componentWillUnmount() {
    if (this.el) {
      this.io.unobserve(this.el);
    }
  }

  render() {
    const { data } = this.props;

    return (
      <div
        className={styles["ArticleKindsItem"]}
        onClick={() => {
        }}
        ref={(el) => (this.el = el)}
      >
        <a
          href={`/movies/${data.id}`}
          className={styles["item"]}
          onClick={() => {}}
        >
          <div className={styles["img"]}>
            <img
              src={data.thumb}
              className='w-full h-full'
              alt={data.name}
            />
            <img
              src='https://photo.8891.com.tw/2023/08/15/1692090155275148.png'
              className='absolute top-0 left-0 right-0 bottom-0 m-auto w-32 h-40'
            />
          </div>
          <div className='flex flex-col border-1 border-solid border-[#e8e8e8] pb-8 w-full py-8 px-10'>
            <p className='line-clamp-2 text-16 text-[#666666] w-290 h-44'>
              {data.title}
            </p>
            <div className='flex justify-between mt-8'>
              {data.author !== ''  && <span className='text-12 text-[#999999]'>{data.author}</span>}
              {data.views !== ''  && <span className='text-12 text-[#999999]'>播放{data.views}次</span>}
            </div>
          </div>
        </a>
      </div>
    );
  }
}

export default ArticleKindsItem;
